module.exports = __webpack_public_path__ + "img/banner22.e2e933c4.png";